// extracted by mini-css-extract-plugin
module.exports = {"root":"Accordion_root__aeB6w"};